import React, { useEffect, useState } from "react";
import { Steps } from "intro.js-react";
import "intro.js/introjs.css?__remix_sideEffect__";
import { useTour } from "../../context/TourContext";
import "./customToolTip.css?__remix_sideEffect__";
import { useRoot } from "../../context/RootContext";

const TaskScreenTour = ({ onStep5, taskDataLength, tourdata }) => {
  const { tourState, setTourState } = useTour();
  const { setOpenProfileMenu } = useRoot();

  const onExit = () => {
    setOpenProfileMenu(true);
    setTourState((prev) => ({ ...prev, enabled: false }));
  };

  const onComplete = () => {
    onStep5?.(false, true);
    // onStep6?.(true);
    setTourState((prev) => ({
      ...prev,
      enabled: false,
      showProfileStep: true
    }));
  };

  const onBeforeChange = async (nextStepIndex) => {
    setTourState((prev) => ({
      ...prev,
      currentStep: prev.currentStep + 1
    }));
    // if (taskDataLength === 0 && nextStepIndex === 0) {
    //   onStep5?.(true);
    // } else
    if (nextStepIndex === 1) {
      onStep5?.(true);
    }
  };

  return (
    <Steps
      enabled={tourState.enabled}
      steps={tourdata}
      initialStep={tourState.currentStep}
      onExit={onExit}
      onComplete={onComplete}
      onBeforeChange={onBeforeChange}
      options={{
        dontShowAgain: false,
        exitOnOverlayClick: false,
        showStepNumbers: false,
        showBullets: false,
        showProgress: false,
        nextLabel: "Next",
        prevLabel: "Back",
        skipLabel: "",
        doneLabel: "Next",
        showCloseButton: true,
        tooltipClass: "custom-tooltip",
        highlightClass: "custom-highlight"
      }} />);


};

export default TaskScreenTour;